<template>
    <label
        :for="name"
        class="z-textarea"
        :class="{
            'is-error': error,
            'is-filled': val,
            'is-focused': focus,
            'is-disabled': disabled
        }"
    >
        <textarea
            :id="name"
            :name="name"
            :value="val"
            autocomplete="off"
            :disabled="disabled"
            @blur="focus = false"
            @focus="focus = true"
            @input="input($event.target.value)"
            @change="change($event.target.value)"
            @keyup.enter="change($event.target.value)"
            :maxlength="maxlength"
        />
        <span
            v-html="placeholder"
            class="z-textarea__placeholder"
            v-if="placeholder"
        ></span>
        <span
            class="z-textarea__error"
            v-if="required && error"
        >
            <span v-if="!val">{{ text.errors.required }}</span>
        </span>
    </label>
</template>

<script>
export default {
    name: 'z-textarea',
    props: {
        name: {
            type: String,
            required: true
        },
        disabled: Boolean,
        required: Boolean,
        placeholder: String,
        maxlength: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            error: false,
            focus: false,
            text: {
                errors: {
                    required: this.$root.lang === 'ru' ? 'Поле обязательно для заполнения' : 'Required field'
                }
            }
        }
    },
    computed: {
        val: {
            get () {
                return this.$attrs.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
        focus (state) {
            this.error = this.required && !state && !this.val.length
        }
    },
    methods: {
        resetVal () {
            if (this.val.length > 0) {
                this.val = ''
                this.change('')
            }
        },
        change (value) {
            this.validate(value)
            this.$emit('change', value)
        },
        input (value) {
            this.validate(value)
            this.$emit('input', value)
        },
        validate () {
            if (this.required && !this.val) {
                this.error = true
            } else {
                this.error = false
            }
        }
    }
}

</script>

<style lang="scss" src="./index.scss"></style>
